<template>
    <div class="modal" :class="{ 'is-active': isActive }">
        <div class="modal-background" @click="close"></div>
        <div class="modal-card" :class="{ 'is-large': large }">
            <header v-if="title" class="modal-card-head">
                <slot name="header">
                    <p class="modal-card-title mb-0">{{ title }}</p>
                    <button class="delete" aria-label="close" @click="close"></button>
                </slot>
            </header>
            <section class="modal-card-body">
                <slot></slot>
            </section>
            <footer class="modal-card-foot is-justify-end">
                <slot name="footer">
                </slot>
            </footer>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: String,
        modalKey: String|Boolean,
        active: {
            type: Boolean,
            default: false
        },
        large: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        isActive () {
            return this.modalKey
                ? this.$store.getters.modalState(this.modalKey)
                : this.active
        }
    },

    methods: {
        close () {
            this.$emit('closed', true)

            if (this.modalKey) {
                this.$store.dispatch('setModalState', { modal: this.modalKey, value: false })
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.is-justify-end {
    justify-content: flex-end;
}
.is-large {
    width: 100%;
    max-width: 1000px;
}
</style>
